import React, { useRef } from 'react';
import MatchStrip from "../MatchStrip";
import Match from "../Match";
import MatchInfo from "../MatchInfo";
import Broadcasters from "../Broadcasters";
import TvStreaming from "../TvStreaming";
import MatchWatch from "../MatchWatch";
import MatchLink from "../MatchLink";
import Odds from "../Odds";
import MatchHeader from "../MatchHeader";
import { listTypes, useMatchList } from "../../utils";
import MatchPromoGroup from "../MatchPromoGroup";
import { useReactAppState } from "../../../shared/containers/utils";
import { trackMatchInteraction } from '../../../../libraries/_modules/tracking/helpers';

function MatchGroup({ matchList, listType, dateRangeType, weekRange, hideMatchPromos, showSecondaryTeams = false, betMgmCompetitionIds = null }) {
  const { mediaQueries, urlList, directoryList } = useReactAppState();
  const { baseUrl } = urlList || {};
  const { matchHubDir } = directoryList || {};
  const { isMediumLargeMin } = mediaQueries || {};
  const matchPosition = useRef(0);

  const formattedMatchList = useMatchList({ matchList, dateRangeType, weekRange });

  if (formattedMatchList == null) {
    return null;
  }

  const handleClick = (e, position, slug, status, competitionSlug) => {
    trackMatchInteraction({
      clickType: 'match',
      clickItem: 'match-unit',
      clickPosition: position,
      match: slug,
      matchState: status?.abbreviation,
      competition: competitionSlug,
    });
    e.stopPropagation();
  };

  return (
    formattedMatchList.map((matchGroup, i) => {
      return (
        <div key={`${matchGroup.date}-${i}`} className="mls-c-schedule__match-group">
          <MatchHeader matchDate={matchGroup.date} dateRangeType={dateRangeType} showTimeZone={i === 0} />
          {
            matchGroup.matches && matchGroup.matches.length > 0
              ? matchGroup.matches.map((match, j) => {
                if (i === 0 && j === 0) matchPosition.current = 0;
                matchPosition.current++;

                const { optaId, competition, season, slug } = match || {};
                const { optaId: seasonOptaId } = season || {};
                const { slug: competitionSlug } = competition || {};

                const matchPageUrl = `${baseUrl}/${matchHubDir}/${competitionSlug}/${seasonOptaId}/matches/${slug}`;
                const position = matchPosition.current;
                return (
                  <React.Fragment key={`${optaId}-${i}-${j}`}>
                    {
                      isMediumLargeMin
                        ? (
                          <MatchStrip
                            showSecondaryTeams={showSecondaryTeams}
                            matchPageUrl={matchPageUrl}
                            listType={listType}
                            match={match} >
                            {match?.optaId > 0 ? <MatchLink matchOptaId={match.optaId} matchPageUrl={matchPageUrl} position={position} slug={slug} competitionSlug={competitionSlug} /> : null}
                            <div className="mls-o-match-strip__left-side">
                              <Match isFullDate includeTitle={listType === listTypes.tv} position={position} />
                            </div>
                            <div className="mls-o-match-strip__right-side">
                              <MatchInfo />
                              <TvStreaming />
                              <Broadcasters />
                              <MatchWatch position={position} />
                              <Odds betMgmCompetitionIds={betMgmCompetitionIds} />
                            </div>
                            {hideMatchPromos ? null : <MatchPromoGroup />}

                          </MatchStrip>
                        )
                        : (
                          <MatchStrip
                            showSecondaryTeams={showSecondaryTeams}
                            listType={listType}
                            match={match}
                          >
                            {match?.optaId > 0 ? < MatchLink matchOptaId={match.optaId} matchPageUrl={matchPageUrl} position={position} slug={slug} competitionSlug={competitionSlug} /> : null}
                            <Match isFullDate includeTitle includeMatchWatch includeBroadcasters position={position} />
                            <TvStreaming />
                            <Odds betMgmCompetitionIds={betMgmCompetitionIds} />
                            {hideMatchPromos ? null : <MatchPromoGroup />}
                          </MatchStrip>
                        )
                    }
                  </React.Fragment>
                );
              })
              : null
          }
        </div>
      );
    }
    )
  );
}

// eslint-disable-next-line no-func-assign
MatchGroup = React.memo(MatchGroup);

export default MatchGroup;
